import { useEffect } from 'react'

function useCalculateScrollbarWidth() {
  useEffect(() => {
    const calc = () => {
      const actualScrollbarWidth = Math.max(
        0,
        window.innerWidth - document.documentElement.clientWidth,
      )
      document.documentElement.style.setProperty(
        '--scrollbar-width',
        `${actualScrollbarWidth}px`,
      )
    }
    // Calculate on component mount and window resize
    calc()
    window.addEventListener('resize', calc)
    return () => window.removeEventListener('resize', calc)
  }, [])
}

export default useCalculateScrollbarWidth
